import React, { useState } from 'react'
import arrow from '../../../asset/icons/right_arrow.svg'

const TableCard = props => {
  const { dataKeys, headers } = props.structure
  const [showSubMenu, setShowSubMenu] = useState(false)
  const clickSubMenu = () => {
    setShowSubMenu(prev => !prev)
  }
  const fillCard = rowContent => {
    const filler = []
    const arrowClass = showSubMenu ? 'w15 trf-rz90': 'w15'
    const uniqueID = props.structure?.rowKey ? rowContent[props.structure.rowKey] : '0'
    let topTwo = []
    for (let i = 0; i <2; i++){
      const value = dataKeys[i]
      if (
        props.structure.rowFormat &&
        props.structure.rowFormat[value] &&
        props.structure.rowFormat[value].format
      ) {
        topTwo[i] =  props.structure.rowFormat[value].format(
          rowContent[value]
        )
      } else {
        topTwo[i] = (<div>{rowContent[dataKeys[i]]}</div>)
      }
    }
    filler.push((
      <div key={uniqueID+'header'} className='df fxdrc'>
        <div className='df w100% h44' onClick={clickSubMenu} key={`${dataKeys[0]}-${dataKeys[1]}`}>
          <img className={arrowClass} src={arrow} alt='dropdown arrow'/>
          <div className='df jcsb w100% aic'>
            {topTwo[0]}
            {topTwo[1]}
          </div>
        </div>
      </div>
    ))
    if (showSubMenu){
      for (let i = 2; i < props.structure.headers.length; i++) {
        const value = dataKeys[i]
        if (
          props.structure.rowFormat &&
          props.structure.rowFormat[value] &&
          props.structure.rowFormat[value].format
        ) {
          filler.push((
            <div className='df jcsb w100% pl15 h44 aic' key={value}>
              <div>{headers[i].value}</div>
              {(value &&
                props.structure.rowFormat[value].format(
                  rowContent[value]
                ))}
            </div>
          ))
        } else {
          filler.push((
            <div className='df jcsb w100% pl15 h44 aic' key={value}>
              <div>{headers[i].value}</div>
              {
                rowContent[value]
              }
            </div>
          ))
        }
      }
    }
    return filler
  }

  return (
    <div className='df fxdrc bb1-s-gray2 pl16 pr16'>
      {fillCard(props.rowContent)}
    </div>
    
  )
}

export default TableCard